import AnalysisTools from '../components/Analysis/AnalysisTools';
import Buffer from '../components/Analysis/Buffer';
import Clip from '../components/Analysis/Clip';
import Dissolve from '../components/Analysis/Dissolve';
import Erase from '../components/Analysis/Erase';
import IdentificationTools from '../components/Analysis/IdentificationTools';
import Intersect from '../components/Analysis/Intersect';
import Merge from '../components/Analysis/Merge';
import SelectFeature from '../components/Analysis/SelectFeature';
import Union from '../components/Analysis/Union';
import Draw from '../components/Drawing/Draw';
import DrawByCoords from '../components/Drawing/DrawByCoords';
import Measure from '../components/Measure/Measure';
import InitialBounds from '../components/Navigation/InitialBounds';
import NavigationHistory from '../components/Navigation/NavigationHistory';
import ZoomBox from '../components/Navigation/ZoomBox';
import BaseMapSwitcher from '../components/Permanent/BaseMapSwitcher';
import ExportProject from '../components/Permanent/ExportProject';
import ImportProject from '../components/Permanent/ImportProject';
import Print from '../components/Permanent/Print';
import ProtectedAreasReport from '../components/Permanent/ProtectedAreasReport';
import ResetMap from '../components/ReloadPage/ResetMap';
import ChangeMosaic from '../components/RemoteAnalysis/ChangeMosaic';
import PrintTwoBaseMaps from '../components/RemoteAnalysis/PrintTwoBaseMaps';
import RemoteAnalysisTools from '../components/RemoteAnalysis/RemoteAnalysisTools';
import SideBySide from '../components/RemoteAnalysis/SideBySide';
import InsertText from '../components/Text/InsertText';

export default {
  // Ferramentas de Análise
  'CPN-TB-A-ANALYSIS-TOOLS': AnalysisTools,
  'CPN-TB-A-IDENTIFICATION-TOOLS': IdentificationTools,
  'CPN-TB-A-SELECT-FEATURE': SelectFeature,
  'CPN-TB-A-BUFFER': Buffer,
  'CPN-TB-A-INTERSECT': Intersect,
  'CPN-TB-A-MERGE': Merge,
  'CPN-TB-A-UNION': Union,
  'CPN-TB-A-DISSOLVE': Dissolve,
  'CPN-TB-A-CLIP': Clip,
  'CPN-TB-A-Erase': Erase,
  // Ferramenta de Recarregar Página
  'CPN-TB-N-RESET-MAP': ResetMap,
  // Ferramentas de Navegação
  'CPN-TB-N-NAVIGATION-HISTORY': NavigationHistory,
  'CPN-TB-N-INITIAL-BOUNDS': InitialBounds,
  'CPN-TB-N-ZOOM-BOX': ZoomBox,
  // Ferramentas de Desenho
  'CPN-TB-D-DRAW': Draw,
  'CPN-TB-D-DRAW-COORDS': DrawByCoords,
  // Ferramentas de Texto
  'CPN-TB-T-INSERT-TEXT': InsertText,
  // Ferramentas de Medidas
  'CPN-TB-M-MEASURE': Measure,
  // Ferramentas da Lateral
  'CPN-TB-P-BASEMAP-SWITCHER': BaseMapSwitcher,
  'CPN-TB-P-EXPORT_PROJECT': ExportProject,
  'CPN-TB-P-IMPORT_PROJECT': ImportProject,
  'CPN-TB-P-PRINT': Print,
  'CPN-TB-P-PROTECTED-AREAS-REPORT': ProtectedAreasReport,
  //Ferramenta de Autuação Remota
  'CPN-TB-RA-REMOTE-ANALYSIS-TOOLS': RemoteAnalysisTools,
  'CPN-TB-RA-CHANGE-MOSAIC': ChangeMosaic,
  'CPN-TB-RA-SIDE-BY-SIDE': SideBySide,
  'CPN-TB-RA-SIDE-BY-SIDE-PRINT': PrintTwoBaseMaps,
};
